import type {ColorAreaProps} from "../types";

import {cn} from "@heroui/react";
import {ColorArea as AriaColorArea, ColorThumb} from "react-aria-components";
import {tv} from "tailwind-variants";

import {focusRing} from "../utils/focus";

const colorAreaStyles = tv({
  base: "border-border size-[232px] shrink-0 rounded-2xl border forced-colors:bg-[GrayText]",
});

const colorThumbStyles = tv({
  base: "size-6 rounded-full border-2 border-white shadow-lg forced-colors:bg-[Canvas]!",
  extend: focusRing,
});

export function ColorArea({className, colorSpace = "hsb", xChannel, yChannel}: ColorAreaProps) {
  return (
    <AriaColorArea
      className={cn(colorAreaStyles(), className)}
      colorSpace={colorSpace}
      xChannel={xChannel}
      yChannel={yChannel}
    >
      <ColorThumb
        className={colorThumbStyles()}
        style={({color}) => ({background: color.toString("css")})}
      />
    </AriaColorArea>
  );
}
